exports = module.exports = require("../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "multi-slider {\n  position: relative;\n  display: block;\n  height: 28rem; }\n  multi-slider > .container {\n    display: flex;\n    height: 100%; }\n    multi-slider > .container .group {\n      flex: 1;\n      max-width: 100%; }\n      multi-slider > .container .group:not(:last-child) {\n        margin-right: .125rem; }\n  multi-slider loading-spinner {\n    position: absolute;\n    top: 50%;\n    left: 50%;\n    transform: translate(-50%, -50%); }\n", ""]);

// exports
